import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import './App.scss';
import api from './api';
import apifunctions from './api/functions.js';
import { DefaultLayout } from './containers';
import { Login, Page404, Page500, Register } from './views/Pages';
import useFacebookPixel from './hooks/useFacebookPixel';

import logo from './assets/img/logo.png'; // Ajusta la ruta si es necesaria

const App = () => {
  const [configuracion, setConfiguracion] = useState({
    Sitio: {
      Nombre: "SHOPPING CIUDAD MÁGICA",
      Correo: 'shoppingciudadmagicabb@gmail.com',
      ComentarioPiePagina: 'Para consultarnos por un producto que te interese o bien tu compra, mándanos un mensaje via chat o telefono y nos pondremos en contacto.',
      DireccionLocal1: 'Jujuy 2010, Bahía Blanca',
      DireccionLocal2: '25 de mayo 595, Bahía Blanca',
      ImagenEmpresa_url: '',
      TelefonoWassapLocal1: '2915038314',
      TelefonoWassapLocal2: '2914642277',
      TelefonoLocal1: '0291 503-8314',
      TelefonoLocal2: '0291 464-2277',
      Instagram: 'https://www.instagram.com/shoppingciudadmagica/',
      Servicio1Title: 'Variedad de productos',
      Servicio2Title: 'Envíos rápidos',
      Servicio3Title: 'Facilidad de pago',
      Servicio1Content: 'Disponemos de una amplia variedad de productos para el hogar, herramientas, electrodomesticos, cuidado personal y más.',
      Servicio2Content: 'Selecciona los productos que te interesan, elegí la forma de pago y nos estaremos comunicando para coordinar el envío hacia tu domicilio.',
      Servicio3Content: 'Podés abonar en tu domicilio tanto efectivo como con tarjeta de crédito, tenes en cuenta que también damos crédito solo con tu dni.',
    },
  });

  // Inicializa el Pixel de Facebook (solo una vez)
  useFacebookPixel('4403012776452805');

  useEffect(() => {
    // Carga configuración desde API
    apifunctions.get(
      api.api.gestion.getHomeConfig,
      null,
      null,
      null,
      (data) => {
        if (data.success && data.data) {
          const newConfig = { Sitio: { Nombre: 'SIGE ECOMMERCE', ...data.data } };
          // Determinar URL de logo
          let imagenUrl = newConfig.Sitio.ImagenEmpresa_url || logo;
          // Actualizar estado y localStorage
          setConfiguracion({ Sitio: { ...newConfig.Sitio, ImagenEmpresa_url: imagenUrl } });
          localStorage.setItem('ImagenEmpresa_url', imagenUrl);
        }
      }
    );
  }, []);

  return (
    <Router>
      <Switch>
        <Route exact path="/404" component={Page404} />
        <Route exact path="/500" component={Page500} />
        <Route path="/" render={() => <DefaultLayout Configuracion={configuracion} />} />
      </Switch>
    </Router>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js